import { Link } from 'react-router-dom';

function clientName(original) {
  return (
    <Link to={`/serviceadministratorclients/edit/${original?.id}`}>
      {original?.clientName || ''}
    </Link>
  );
}

function clientNumber(original) {
  return original?.clientNumber || '';
}

function underwriterApprovalRequired(original) {
  return original?.underwriterApprovalRequired ? 'Yes' : 'No';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { clientName, clientNumber, underwriterApprovalRequired, status };
